import type { RevenueTargetStateBreakdown } from './RevenueTargetMetricsCard';
import type {
  Location,
  SalesPipelineStage,
} from '../../types';
import type { ProductCompanyLocation } from '../../types';

export type PipelineDrawerMetricsOverride = {
  stageCounts: Record<SalesPipelineStage, number>;
  stageValues: Record<SalesPipelineStage, number>;
  totalCount: number;
  totalValue: number;
};

export type TableColumnKey =
  | 'type'
  | 'name'
  | 'address'
  | 'city'
  | 'state'
  | 'zip'
  | 'country'
  | 'staff'
  | 'orders'
  | 'products'
  | 'quotation_count'
  | 'enquiry_count'
  | 'target'
  | 'target_year'
  | 'target_achievement'
  | 'total_amount'
  | 'revenue_share'
  | 'email'
  | 'phone'
  | 'action';

export const createDefaultTableColumnVisibility = (): Record<TableColumnKey, boolean> => ({
  type: false,
  name: true,
  address: false,
  city: false,
  state: false,
  zip: false,
  country: false,
  staff: true,
  orders: true,
  products: true,
  quotation_count: false,
  enquiry_count: false,
  target: true,
  target_year: true,
  target_achievement: true,
  total_amount: true,
  revenue_share: true,
  email: false,
  phone: false,
  action: true,
});

export type RevenueTargetCompanyEntry = {
  name: string;
  userid?: string;
  city?: string;
};

export type RevenueTargetRepEntry = {
  name: string;
  companyCount: number;
  revenue: number;
  topCity?: string;
  topCityCount?: number;
  cities: Record<string, number>;
};

export type RevenueCompanyDetailRow = {
  company: string;
  userid?: string;
  city?: string;
  state?: string;
  salesReps: string[];
  target: number;
  achieved: number;
  locationCount: number;
};

export type RevenueRepDetailRow = {
  name: string;
  companyCount: number;
  revenue: number;
  topCity?: string;
  topCityCount?: number;
};

export type RevenueTargetDrawerRow = RevenueTargetStateBreakdown & {
  companies: RevenueTargetCompanyEntry[];
  locations: Location[];
  reps: RevenueTargetRepEntry[];
  topCity?: string;
  topCityCount?: number;
};

export type ProductLocationCollector = globalThis.Map<string, ProductCompanyLocation>;
